export const generatedMenuItems = [
    {
        type: 'group',
        name: 'administration-menu-item',
        label: 'Administrace',
        parent: null,
        routes: [],
    },
    {
        type: 'group',
        name: 'core-menu-item',
        label: 'Core',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'core-setting-menu-item',
        label: 'Nastavení',
        parent: 'core-menu-item',
        routes: ['default-core-setting-browser', 'default-core-setting-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'core-timezone-menu-item',
        label: 'Časové zóny',
        parent: 'core-menu-item',
        routes: ['default-core-timezone-browser', 'default-core-timezone-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'core-user-menu-item',
        label: 'Uživatelé',
        parent: 'core-menu-item',
        routes: ['default-core-user-browser', 'default-core-user-editor'],
        privileges: [["manageUsers"],["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-privilege-menu-item',
        label: 'Oprávnění',
        parent: 'core-menu-item',
        routes: ['default-core-privilege-browser', 'default-core-privilege-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-role-menu-item',
        label: 'Role',
        parent: 'core-menu-item',
        routes: ['default-core-role-browser', 'default-core-role-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-roleprivilege-menu-item',
        label: 'Oprávnění role',
        parent: 'core-menu-item',
        routes: ['default-core-roleprivilege-browser', 'default-core-roleprivilege-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-userrole-menu-item',
        label: 'Role uživatele',
        parent: 'core-menu-item',
        routes: ['default-core-userrole-browser', 'default-core-userrole-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-permission-menu-item',
        label: 'Přístupová oprávnění',
        parent: 'core-menu-item',
        routes: ['default-core-permission-browser', 'default-core-permission-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-foldertype-menu-item',
        label: 'Typy složek',
        parent: 'core-menu-item',
        routes: ['default-core-foldertype-browser', 'default-core-foldertype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-folder-menu-item',
        label: 'Složky',
        parent: 'core-menu-item',
        routes: ['default-core-folder-browser', 'default-core-folder-editor'],
        privileges: [["useFileRepository"]],
    },
    {
        type: 'item',
        name: 'core-folderpermission-menu-item',
        label: 'Přístupová práva složek',
        parent: 'core-menu-item',
        routes: ['default-core-folderpermission-browser', 'default-core-folderpermission-editor'],
        privileges: [["adminFileRepository"]],
    },
    {
        type: 'item',
        name: 'core-filetype-menu-item',
        label: 'Typy souborů',
        parent: 'core-menu-item',
        routes: ['default-core-filetype-browser', 'default-core-filetype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-file-menu-item',
        label: 'Soubory',
        parent: 'core-menu-item',
        routes: ['default-core-file-browser', 'default-core-file-editor'],
        privileges: [["useFileRepository"]],
    },
    {
        type: 'item',
        name: 'core-workflow-menu-item',
        label: 'Workflow',
        parent: 'core-menu-item',
        routes: ['default-core-workflow-browser', 'default-core-workflow-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'item',
        name: 'core-workflowstatus-menu-item',
        label: 'Stavy workflow',
        parent: 'core-menu-item',
        routes: ['default-core-workflowstatus-browser', 'default-core-workflowstatus-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'item',
        name: 'core-workflowtransition-menu-item',
        label: 'Přechody workflow',
        parent: 'core-menu-item',
        routes: ['default-core-workflowtransition-browser', 'default-core-workflowtransition-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'item',
        name: 'core-workflowtransitionprivilege-menu-item',
        label: 'Oprávnění přechodů workflow',
        parent: 'core-menu-item',
        routes: ['default-core-workflowtransitionprivilege-browser', 'default-core-workflowtransitionprivilege-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'group',
        name: 'customers-menu-item',
        label: 'Customers',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'customers-person-menu-item',
        label: 'Osoby',
        parent: 'customers-menu-item',
        routes: ['default-customers-person-browser', 'default-customers-person-editor'],
        privileges: [["manageCustomers"],["adminCustomers"]],
    },
    {
        type: 'item',
        name: 'customers-address-menu-item',
        label: 'Adresy',
        parent: 'customers-menu-item',
        routes: ['default-customers-address-browser', 'default-customers-address-editor'],
        privileges: [["manageCustomers"],["adminCustomers"]],
    },
    {
        type: 'item',
        name: 'customers-customer-menu-item',
        label: 'Zákazníci',
        parent: 'customers-menu-item',
        routes: ['default-customers-customer-browser', 'default-customers-customer-editor'],
        privileges: [["manageCustomers"],["adminCustomers"]],
    },
    {
        type: 'item',
        name: 'customers-customerperson-menu-item',
        label: 'Osoby zákazníka',
        parent: 'customers-menu-item',
        routes: ['default-customers-customerperson-browser', 'default-customers-customerperson-editor'],
        privileges: [["manageCustomers"],["adminCustomers"]],
    },
    {
        type: 'item',
        name: 'customers-customeraddress-menu-item',
        label: 'Adresa zákazníka',
        parent: 'customers-menu-item',
        routes: ['default-customers-customeraddress-browser', 'default-customers-customeraddress-editor'],
        privileges: [["manageCustomers"],["adminCustomers"]],
    },
    {
        type: 'group',
        name: 'employees-menu-item',
        label: 'Employees',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'employees-employee-menu-item',
        label: 'Zaměstnanci',
        parent: 'employees-menu-item',
        routes: ['default-employees-employee-browser', 'default-employees-employee-editor'],
        privileges: [["manageEmployees"],["adminEmployees"]],
    },
    {
        type: 'group',
        name: 'machines-menu-item',
        label: 'Machines',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'machines-enginefueltype-menu-item',
        label: 'Typy paliv',
        parent: 'machines-menu-item',
        routes: ['default-machines-enginefueltype-browser', 'default-machines-enginefueltype-editor'],
        privileges: [["adminMachines"]],
    },
    {
        type: 'item',
        name: 'machines-enginetype-menu-item',
        label: 'Typy strojů',
        parent: 'machines-menu-item',
        routes: ['default-machines-enginetype-browser', 'default-machines-enginetype-editor'],
        privileges: [["adminMachines"]],
    },
    {
        type: 'item',
        name: 'machines-generatortype-menu-item',
        label: 'Typy generátorů',
        parent: 'machines-menu-item',
        routes: ['default-machines-generatortype-browser', 'default-machines-generatortype-editor'],
        privileges: [["adminMachines"]],
    },
    {
        type: 'item',
        name: 'machines-machinestatus-menu-item',
        label: 'Stavy strojů',
        parent: 'machines-menu-item',
        routes: ['default-machines-machinestatus-browser', 'default-machines-machinestatus-editor'],
        privileges: [["adminMachines"]],
    },
    {
        type: 'item',
        name: 'machines-machine-menu-item',
        label: 'Stroje',
        parent: 'machines-menu-item',
        routes: ['default-machines-machine-browser', 'default-machines-machine-editor'],
        privileges: [["manageMachines"],["adminMachines"]],
    },
    {
        type: 'group',
        name: 'work-menu-item',
        label: 'Work',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'work-workholiday-menu-item',
        label: 'Státní svátky',
        parent: 'work-menu-item',
        routes: ['default-work-workholiday-browser', 'default-work-workholiday-editor'],
        privileges: [["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-workgroup-menu-item',
        label: 'Skupiny prací',
        parent: 'work-menu-item',
        routes: ['default-work-workgroup-browser', 'default-work-workgroup-editor'],
        privileges: [["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-workactivity-menu-item',
        label: 'Pracovní aktivity',
        parent: 'work-menu-item',
        routes: ['default-work-workactivity-browser', 'default-work-workactivity-editor'],
        privileges: [["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-worktype-menu-item',
        label: 'Typy prací',
        parent: 'work-menu-item',
        routes: ['default-work-worktype-browser', 'default-work-worktype-editor'],
        privileges: [["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-workactivityaction-menu-item',
        label: 'Akce k typům aktivit',
        parent: 'work-menu-item',
        routes: ['default-work-workactivityaction-browser', 'default-work-workactivityaction-editor'],
        privileges: [["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-workcontract-menu-item',
        label: 'Zakázky',
        parent: 'work-menu-item',
        routes: ['default-work-workcontract-browser', 'default-work-workcontract-editor'],
        privileges: [["manageWork"],["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-workschedule-menu-item',
        label: 'Rozpisy prací',
        parent: 'work-menu-item',
        routes: ['default-work-workschedule-browser', 'default-work-workschedule-editor'],
        privileges: [["editWork"],["manageWork"],["adminWork"]],
    },
    {
        type: 'item',
        name: 'work-workevent-menu-item',
        label: 'Pracovní události',
        parent: 'work-menu-item',
        routes: ['default-work-workevent-browser', 'default-work-workevent-editor'],
        privileges: [["manageWork"],["adminWork"]],
    },
];
